import React from 'react';
import { useScreenInit } from '../useScreenInit';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { HowItWorks } from '../components/HowItWorks';
import { PrivacySection } from '../components/PrivacySection';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function Home() {
  useScreenInit();
  return <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-193">
      <Navbar data-id="element-194" />
      <main className="flex-1" data-id="element-195">
        <Hero data-id="element-196" />
        <Features data-id="element-197" />
        <HowItWorks data-id="element-198" />
        <PrivacySection data-id="element-199" />
        <FAQ data-id="element-200" />
        <FinalCTA data-id="element-201" />
      </main>
      <Footer data-id="element-202" />
    </div>;
}